import {useDebugValue} from 'react';

import {
    useDestinationActions,
    useDestinationEvents,
    useDestinationOptions,
    useDestinationSelectors,
    useDestinationSettings,
    useDestinationTranslations,
    useDestinationValues
} from './';

function useDestination(props, cookies) {
    const {
        events
    } = useDestinationEvents(props);

    const {
        options
    } = useDestinationOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useDestinationSettings(props);

    const {
        translations
    } = useDestinationTranslations(props);

    const {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useDestinationValues(props, cookies);

    const actions = useDestinationActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings,
        translations,
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    });

    const selectors = useDestinationSelectors({
        options,
        settings,
        translations,
        currentValues,
        latestValues
    });

    const result = {
        actions,
        events,
        options,
        selectors,
        settings,
        translations,
        currentValues,
        latestValues
    };

    useDebugValue(result);

    return result;
}

export {useDestination};
